import React from 'react'

export default function Footee() {
  return (
    <div className='bg-black  '>
        <h3 className='text-white text-2xl font-bold text-center'>Social</h3>
        <div className='flex justify-center mt-6 space-x-4'>
        <img className='w-10 bg-white rounded-full' src='https://cdn-icons-png.flaticon.com/512/4138/4138173.png' />
        <img className='w-10 bg-white rounded-full' src='https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png' />
        <img className='w-10 bg-white rounded-full' src='https://w7.pngwing.com/pngs/274/823/png-transparent-icon-essential-instagram-2016-app-logo-vector-images-social-networks.png' />
</div>
    </div>
  )
}
